var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_vm._v("\n  This should never be visible in production\n")])}
var staticRenderFns = []

export { render, staticRenderFns }